// Desktop menu: clicking a menu link grows a white circle out of the clicked word until it fills the screen, then the page changes.
// Same effect as the phone menu (s-mobile-nav.js). Place <s-nav-expand hidden> inside the desktop <nav data-desktop-nav>.
class SNavExpand extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const nav = this.closest('[data-desktop-nav]');
    if (!nav) return;

    nav.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (link && nav.contains(link)) this.#expandTo(link, event);
    }, opts);

    // Coming back with the browser's back button can restore the page mid-transition; clear the white cover.
    window.addEventListener('pageshow', () => {
      document.querySelectorAll('[data-nav-expand]').forEach((el) => el.remove());
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #expandTo(link, event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== '_self') return;
    if (link.hash && link.pathname === window.location.pathname) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const cover = document.createElement('div');
    if (typeof cover.showPopover !== 'function' || typeof cover.animate !== 'function') return;

    event.preventDefault();
    const box = link.getBoundingClientRect();
    const x = event.clientX || box.left + box.width / 2;
    const y = event.clientY || box.top + box.height / 2;
    const radius = Math.hypot(Math.max(x, window.innerWidth - x), Math.max(y, window.innerHeight - y));

    cover.setAttribute('popover', 'manual');
    cover.setAttribute('aria-hidden', 'true');
    cover.dataset.navExpand = '';
    Object.assign(cover.style, {
      position: 'fixed', inset: '0', width: '100vw', height: '100dvh', maxWidth: 'none', maxHeight: 'none',
      margin: '0', padding: '0', border: '0', background: '#FFFFFF', pointerEvents: 'none',
      clipPath: `circle(0px at ${x}px ${y}px)`,
    });
    document.body.append(cover);
    cover.showPopover();

    const go = () => { window.location.href = link.href; };
    const animation = cover.animate(
      [{ clipPath: `circle(0px at ${x}px ${y}px)` }, { clipPath: `circle(${radius}px at ${x}px ${y}px)` }],
      { duration: 650, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'forwards' },
    );
    animation.finished.then(go, go);
  }
}

if (!customElements.get('s-nav-expand')) customElements.define('s-nav-expand', SNavExpand);
